import { footer } from './Footer.css';

const Footer = () => {
  return (
    <footer className={footer}>
      <div>방문해주셔서 감사합니다. 좋은 하루 보내세요. 😆</div>
      <div>피드백은 언제나 환영입니다.</div>
    </footer>
  );
};

export default Footer;
